<div *ngIf="loading" [ngSwitch]="size">
  <div *ngSwitchCase="'full'" class="modal on-top" [class.is-active]="loading">
    <div class="modal-background">
      <span class="full-messages"> {{ message }} </span>
    </div>

    <div class="modal-body flex-spinner">
      <div class="spinner"></div>
    </div>
  </div>
  <div *ngSwitchCase="'tiny'">
    <div class="tiny-spinner"></div>
  </div>
  <div *ngSwitchCase="'adapt'">
    <div class="inner">
      <div class="medium-spinner">
        <span class="messages">
          {{ message }}
        </span>
      </div>
    </div>
  </div>
</div>
